import { SessionService } from 'app/core/services/session.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription, Subject } from 'rxjs';

import { OrganizationDetailsService } from './organization-details.service';
import { NotificationService } from '../../../core/services/notification.service';
import { ConfigService } from '../../../core/services/config.service';
import { EnvironmentService } from 'app/core/services/environment.service';
import { AddressCommonService } from '../common/services/address-common.service';

declare var $: any;

@Component({
    selector: 'itpx-organization-details',
    templateUrl: './organization-details.component.html',
    styleUrls: ['./organization-details.component.css']
})
export class OrganizationDetailsComponent extends RxComponent {

    private details: any;
    private accountAdmDetails: any;
    private domainDetails: any;
    private sub: Subscription;
    private id: string;
    private printLogoSrc: string;
    private brandedLogoSrc: string;
    private defaultImage: string;
    private userGroups: any;
    private certificatesData: any;

    private smtpFields = [];
    private gmailSmtpFields = [];
    private sendTestEmailClick = new Subject<any>();

    private overviewFields: Array<any>;
    private accountAdmFields: Array<any>;
    private billingFields: Array<any>;
    private fieldsPrintLogo: Array<any>;
    private fieldsBrandedLogo: Array<any>;
    private addressesFields: Array<any>;
    private certificatesFields: Array<any>;
    private sellerAccountFields: Array<any>;
    private sellerAccountProceedsFields: Array<any>;

    // Certificates details
    private primarySignatoryFields: Array<any>;
    private secondarySignatoryFields: Array<any>;
    private certificatesDetailsFields: Array<any>;

    private isUserAdmin: boolean = false;

    private buttons = [];

    private smtpButtons: any[];
    private brandedPortalBackgroundImageSrc: string;
    isFSPEnv;
    isSeller = false;
    private countryDict;

    constructor(
        private service: OrganizationDetailsService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private sessionService: SessionService,
        private environmentService: EnvironmentService,
        private addressCommonService: AddressCommonService
    ) {
        super();
        this.defaultImage = this.configService.get('images').defaultImage;
    }

    ngOnInit() {
        this.countryDict = this.addressCommonService.getCountries().map(_ => _.data);
        this.isFSPEnv = this.environmentService.isFSPEnv;
        this.service.getDomainDetails()
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.domainDetails = body.data;
                }
            )

        this.sendTestEmailClick
            .flatMap(_ => this.service.sendTestEmail(this.details.id).neverError())
            .bindToLifecycle(this)
            .subscribe(_ => this.notificationService.success(`Test email sent to ${this.sessionService.getUserDetails().username}.`));

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.service.getDetails(this.id)
                .subscribe(
                    data => this.extractData(data)
                );
        });

        this.userGroups = this.sessionService.getUserGroups();

        if (this.service.isUserAdmin()) {
            this.isUserAdmin = true;
            this.buttons.push({
                title: 'Edit',
                action: 'edit',
                icon: 'fa-pencil-square',
                class: 'btn-primary',
                disabled: false
            });
            this.billingFields = this.service.getBillingAdminDetailsFields();
        } else {
            this.billingFields = this.service.getBillingDetailsFields();
        }

        this.overviewFields = this.service.getOverviewDetailsFields();
        this.sellerAccountFields = this.service.getSellerAccountDetailsFields();
        this.sellerAccountProceedsFields = this.service.getSellerAccountProceedsDetailsFields();
        this.accountAdmFields = this.service.getAccountAdmDetailsFields();
        this.addressesFields = this.service.getAddressesDetailsFields();

        this.primarySignatoryFields = this.service.getPrimarySignatoryFields();
        this.secondarySignatoryFields = this.service.getSecondarySignatoryFields();
        this.certificatesDetailsFields = this.service.getCertificatesDetailsFields()

        this.fieldsPrintLogo = this.service.getDetailsPrintLogoFields();
        this.fieldsBrandedLogo = this.service.getDetailsBrandedLogoFields();
        this.smtpFields = this.service.getDetailsSmtpfields();
        this.gmailSmtpFields = this.service.getGmailSmtpFields();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(body: any) {
        this.isSeller = body.data.seller;
        this.details = <any>body.data;
        this.addCountryOriginAndWebsiteContactInFields();
        this.setSellerDetails();

        this.service.getAccountAdmDetails(this.details.accountId)
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.accountAdmDetails = body;
                }
            );

        if (this.details && this.details.seller) {
            this.route.queryParams
                .map(params => params['tab'])
                .filter(tab => tab)
                .bindToLifecycle(this)
                .subscribe(tab => setTimeout(() => $(`.nav-tabs a[href="#${tab}"]`).tab('show'), 500));
        }

        if (this.details.printLogoBucket && this.details.printLogoKey) {
            this.printLogoSrc = this.configService.get('server').sphinx +
                this.configService.get('endpoints').sphinx.proxy.api +
                '/agora/jwt/' + this.details.printLogoBucket + '/' + this.details.printLogoKey;
        } else if (this.details.printLogo == null || this.details.printLogo.length == 0) {
            this.printLogoSrc = this.defaultImage;
        } else {
            this.printLogoSrc = this.details.printLogo;
        }

        if (this.details.brandedPortalLogoBucket && this.details.brandedPortalLogoKey) {
            this.brandedLogoSrc = this.configService.get('server').sphinx +
                this.configService.get('endpoints').sphinx.proxy.api +
                '/agora/jwt/' + this.details.brandedPortalLogoBucket + '/' + this.details.brandedPortalLogoKey;
        } else if (this.details.brandedPortalLogo == null || this.details.brandedPortalLogo.length == 0) {
            this.brandedLogoSrc = this.defaultImage;
        } else {
            this.brandedLogoSrc = this.details.brandedPortalLogo;
        }

        if (this.details.brandedPortalBannerBucket && this.details.brandedPortalBannerKey) {
            this.brandedPortalBackgroundImageSrc = this.configService.get('server').sphinx +
                this.configService.get('endpoints').sphinx.proxy.api +
                '/agora/jwt/' + this.details.brandedPortalBannerBucket + '/' + this.details.brandedPortalBannerKey;
        } else if (this.details.brandedPortalBackgroundImage == null || this.details.brandedPortalBackgroundImage.length == 0) {
            this.brandedPortalBackgroundImageSrc = this.configService.get('images').defaultImage1500x350;
        } else {
            this.brandedPortalBackgroundImageSrc = this.details.brandedPortalBackgroundImage;
        }

        let smtp = this.details.smtpDetails[0];
        if (smtp && !smtp.isDefault) {
            this.smtpButtons = this.buttons.concat(
                {
                    title: 'Send Test Email',
                    action: 'email',
                    icon: 'fa-ban',
                    class: 'btn-default',
                    disabled: true
                }
            );
        } else {
            this.smtpButtons = this.buttons.concat(
                {
                    title: 'Send Test Email',
                    action: 'email',
                    icon: 'fa-paper-plane',
                    class: 'btn-default',
                    disabled: false
                }
            );
        }

        let primarySignatory = this.details.certificateSignatories.find(s => s.type.configKey === 'primary-signatory');
        let secondarySignatory = this.details.certificateSignatories.find(s => s.type.configKey === 'secondary-signatory');
        this.certificatesData = {
            primary: primarySignatory,
            secondary: secondarySignatory,
            deliveryEnabled: this.details.certificateDeliveryEnabled,
            elearningCompletionDeliveryEnabled: this.details.elearningCompletionCertificateDeliveryEnabled
        };
    }
    private addCountryOriginAndWebsiteContactInFields() {
        if (this.isSeller && this.isFSPEnv) {
            this.countryDict
                .bindToLifecycle(this)
                .subscribe((countryDetails) => {
                    let country = this.details.countryOfOrigin;
                    this.details.countryOfOriginName = country ? countryDetails[country] : '';
                });
            let extraFields = [{
                key: 'countryOfOriginName',
                label: 'Country of Origin',
                type: 'text',
                config: {
                    placeholder: 'Please select the country your parent company originated from.'
                }
            },
            {
                key: item => {
                    if (item.companyWebsiteContact  &&  (item.companyWebsiteContact.startsWith('http')|| item.companyWebsiteContact.startsWith('https') )) {
                        return item.companyWebsiteContact;
                      } else {
                        return 'https://' + item.companyWebsiteContact;
                      }
                },
                label: 'Company Website (Contact Us Page) ',
                type: 'link',
                config: {
                    placeholder: 'Website'
                }
            }];
            this.overviewFields = [...this.overviewFields, ...extraFields];
        }
    }
    private setSellerDetails() {
        let sellerAccount = this.details.sellerAccount;
        if (sellerAccount) {
            this.details.sellerAccount.proceeds = [
                {
                    label: 'Hosted',
                    min: sellerAccount.sellerProceedsMin,
                    max: sellerAccount.sellerProceedsMax,
                    percent: sellerAccount.sellerProceedsPercent
                },
                {
                    label: 'Non-Hosted',
                    min: sellerAccount.nonHostedSellerProceedsMin,
                    max: sellerAccount.nonHostedSellerProceedsMax,
                    percent: sellerAccount.nonHostedSellerProceedsPercent
                },
                {
                    label: 'Instructor',
                    min: sellerAccount.instructorSellerProceedsMin,
                    max: sellerAccount.instructorSellerProceedsMax,
                    percent: sellerAccount.instructorSellerProceedsPercent
                },
                {
                    label: 'Other',
                    min: sellerAccount.otherSellerProceedsMin,
                    max: sellerAccount.otherSellerProceedsMax,
                    percent: sellerAccount.otherSellerProceedsPercent
                }
            ]
        }
    }

    private onAction(action: string) {
        if (action == 'edit') {
            this.goToEditScreen();
        } else if (action == 'email') {
            this.sendTestEmailClick.next(true);
        }
    }

    private goToEditScreen() {
        let tab = this.route.snapshot.queryParams['tab'];
        this.router.navigate(
            ['/organization/organization-details', this.details.id, 'edit'],
            tab ? { queryParams: { tab: tab } } : {}
        );
    }

    private onTabClick(e) {
        let tabId = e.srcElement.attributes['href'].value;
        this.router.navigate(
            ['/organization/organization-details'],
            { queryParams: { tab: tabId.substr(1) } }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details.component.ts